export const quantityValidationParameters = {
    required: true,
    integer: true,
    min_value: 1,
    not_in: [0, 0.0, 0.0],
};